var map = {
	"./level1.json": [
		659,
		659
	],
	"./level2.json": [
		330,
		330
	],
	"./level3.json": [
		85,
		85
	],
	"./level4.json": [
		196,
		196
	],
	"./level5.json": [
		735,
		735
	],
	"./level6.json": [
		846,
		846
	],
	"./level7.json": [
		209,
		209
	],
	"./level8.json": [
		640,
		640
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 399;
module.exports = webpackAsyncContext;